import { RoutesService, eLayoutType } from '@abpdz/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eBillingPolicyNames } from '@module/billing/config';
import { eEnrolmentPolicyNames } from './enums/policy-names';
import {
  eEnrolmentRouteNames,
  eEnrolmentRoutePaths,
} from './enums/route-names';

export const ENROLMENT_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

function configureRoutes(routes: RoutesService): any {
  return () => {
    routes.add([
      {
        path: '/' + eEnrolmentRoutePaths.Root + '/' + eEnrolmentRoutePaths.TDB,

        name: eEnrolmentRouteNames.TDB,
        requiredPolicy: eEnrolmentPolicyNames.TDB,
        iconClass: 'dashboard',
        order: 10,
        layout: eLayoutType.application,
      },
      {
        path: '/' + eEnrolmentRoutePaths.Root + '/' + eEnrolmentRoutePaths.TDBLPR,

        name: eEnrolmentRouteNames.TDBLPR,
        requiredPolicy: eEnrolmentPolicyNames.TDBLPR,
        iconClass: 'dashboard',
        order: 10,
        layout: eLayoutType.application,
      },
      {
        path: '/clients',

        name: '/clients/id',
        requiredPolicy: 'onlyforui',
        iconClass: 'dashboard',
        order: 10,
        layout: eLayoutType.application,
      },
    ]);
  };
}
